import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'

import {
  $alert,
  $tips,
  $confirm,
  $hideLoading,
  $showLoading,
  $showBroadcast,
  $hideBroadcast,
  $message,
  $introduce
} from './components/popupLayout'

Vue.config.productionTip = false
Vue.prototype.$cdn = ''
Vue.prototype.$ALL = [];
Vue.prototype.$url="http://localhost:8081"
if(process.env.NODE_ENV === 'production') {
  Vue.prototype.$sceneurl = 'http://www.4dmodel.com/SuperTwoCustom/RuiJinMuseum/SuperTwo/index.html?m=';
  Vue.prototype.$imagesurl = 'https://4dscene.4dage.com/wuhu/RuiJinMuseum';
}else {
  Vue.prototype.$sceneurl = 'http://www.4dmodel.com/SuperTwoCustom/RuiJinMuseum/SuperTwo/index.html?m=';
  Vue.prototype.$imagesurl = 'https://4dscene.4dage.com/wuhu/RuiJinMuseum';
}
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)
Viewer.setDefaults({
  Options: { 'inline': true, 'button': true, 'navbar': true, 'title': false, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})
Vue.mixin({
  methods: {
    $alert,
    $tips,
    $confirm,
    $hideLoading,
    $showLoading,
    $showBroadcast,
    $hideBroadcast,
    $message,
    $introduce
  }
})

let {axios} = require('./utils/http.js')

Vue.prototype.$http = axios
Vue.prototype.$bus = new Vue()


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')